export const CPF_LENGTH = 11;
export const CNPJ_LENGTH = 14;

export const limparCpfCnpj = (value = "") => String(value).replace(/[.\-/\s]/g, "");

export const isCPF = (value = "") => limparCpfCnpj(value).length === CPF_LENGTH;

export const isCNPJ = (value = "") => {
  const cpfCnpjSemMascara = limparCpfCnpj(value);
  return cpfCnpjSemMascara.length === CNPJ_LENGTH && /^\d{2}$/.test(cpfCnpjSemMascara.slice(-2));
};

export const isCpfCnpj = (value = "") => isCPF(value) || isCNPJ(value);
